const auth = `/organisation/customer`;
const common = `/common`;
const user = `/user`;
const service = `/service`;
const organisation = `/organisation`;
const order = `/order`;
const other = `/other`;

export const api_routes = {
  LOGIN: `${auth}/login`,
  SEND_OTP: `${user}/sendOtp`,
  VERIFY_OTP: `${user}/verifyOTP`,
  APP_SETTINGS: `${common}/appSettings`,
  PROTECTED_APP_SETTINGS: `${common}/getProtectedAppSettings`,
  SERVICE_BRANDS: `${common}/serviceBrands`,
  BRAND_PRODUCTS: `${common}/brandProducts`,
  REGISTER_CUSTOMER: `${auth}/register`,
  CUSTOMER_DETAILS: `${user}${service}/homeApi`,
  LOGOUT: `${common}/logout`,
  GETCARDLIST: `${common}/getCardList`,
  ADDCARD: `${common}/addCard`,
  REMOVECARD: `${common}/removeCard`,
  LOGIN_ORGANISATION: `${auth}/login`,
  CONTACT_TO_ADMIN: `${organisation}/contactToAdmin`,
  SERVICE_REQUEST_MAKE_ORDER: `${user}${service}/request`,
  SOCKET_TEST_API: `${common}/TestApiSocket`,
  ORDER_ONGOING_CHECK: `${service}${order}/ongoing`,
  UPDATE_CUSTOMER_INFO: `${user}/profileUpdate`,
  ORDER_HISTORY: `${user}/other/order/history`,
  ORDER_DETAILS: `${user}/other/order/details`,
  ORDER_RATING: `${user}${service}/rate`,
  ORDER_RATING_FOR_HELPER: `${user}${service}/userToHelperRating`,
  ORDER_TIP: `${user}${service}/Tip`,
  ORDER_TIP_FOR_HELPER: `${user}${service}/tipToHelper`,
  CANCEL_ORDER: `${user}${service}/Cancel`,
  PLACE_AUTOCOMPLETE: `${common}/placeAutocomplete`,
  ACCEPT_ORDER_WITHOUT_HELPER: `${service}${order}/acceptOrderWithoutHelper`,
  ORDER_CHAT: `${user}/other/getChat`,
  ORDER_UNREAD_CHAT_COUNT: `${user}/other/getUnreadChatsPerOrder`,
  SERVICE_REQUEST_MAKE_ORDER_MULTIPLE: `${organisation}${service}/request`,
  SEND_MESSAGE: `${common}/sendMessage`,
  GET_CHAT_FOR_HELPER: `${user}${other}/getChatForHelper`,
  SEND_MESSAGE_TO_HELPER: `${common}/sendMessageToHelper`,
  CHECK_PROMO_CODE: `${user}${other}/checkCoupons`,
  FORGOT_PASSWORD: `${auth}/forgotPassword`,
  RESET_PASSWORD: `${auth}/resetForgotPassword`,
  VERIFY_RESET_PASSWORD_TOKEN: `${auth}/verifyForgotPassword`,
  FCM_UPDATE: `${common}/fcmTokenUpdate`,
  CHANGE_PASSWORD: `${auth}/changePassword`,
  SERVICE_REQUEST_MAKE_ORDER_FOR_ONLY_HELPER: `${user}${service}/onlyHelperRequest`,
  OBSTACLE_DETAILS: `${user}${other}${order}/obstacle_details`,
  NOTIFICATION_LISTING: `${service}/notificationListing`,
  READ_NOTIFICATION: `${service}/readNotification`
}

